/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

import { NgModule, Injector, createNgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import devextremeAjax from 'devextreme/core/utils/ajax';
import { sendRequestFactory } from './ajax';

@NgModule({
  exports: [],
  imports: [],
  providers: [],
})
export class DxHttpModule {
  constructor(injector: Injector) {
    let httpClient: HttpClient = injector.get(HttpClient, null);

    if (!httpClient) {
      const moduleRef = createNgModule(HttpClientModule, injector);

      httpClient = moduleRef.injector.get(HttpClient);
    }

    devextremeAjax.inject({ sendRequest: sendRequestFactory(httpClient) });
  }
}
